import { isReadOnly } from '~/helpers'
import i18n from '~/i18n'

import { PlacementsActionColumn } from './ActionColumn'
import AdTypes from './elements/Adtypes'
import MainInfo from './elements/MainInfo'
import SizeBadges from './elements/SizeBadges'

const actionColumn: TableSchemaItem<Placement> = {
  title: i18n.t('rm:placements.list.table.column.title.management'),
  render: rowData => (
    <PlacementsActionColumn rowData={rowData} key={`placement${rowData.id}`} />
  )
}

const schema: () => TableSchema<Placement> = () => ({
  name: {
    title: i18n.t('rm:placements.list.table.column.title.name'),
    render: rowData => <MainInfo data={rowData} />,
    sortKey: 'name'
  },
  context: {
    title: i18n.t('rm:placements.list.table.column.title.context'),
    render: rowData => (
      <span className="placement-context-name">
        {i18n.t('common:capitalize', {
          value: i18n.t(`rm:context.${rowData.context}`)
        })}
      </span>
    ),
    sortKey: 'context'
  },
  adTypes: {
    title: i18n.t('rm:placements.list.table.column.title.format'),
    render: rowData => <AdTypes data={rowData} />
  },
  sizes: {
    title: i18n.t('rm:placements.list.table.column.title.size'),
    render: rowData => <SizeBadges data={rowData} />
  },
  ...(isReadOnly() ? {} : { actions: actionColumn })
})

export default schema
